import { FaGlobe, FaFolder } from 'react-icons/fa6';

type Props = {
  isGlobal: boolean;
  className?: string;
};

const ScopeIndicator = ({ isGlobal, className = '' }: Props) => {
  return (
    <div className={`flex items-center gap-1 ${className}`}>
      {isGlobal ? (
        <>
          <FaGlobe size={14} className="text-purple-500 dark:text-purple-400 sm:hidden" />
          <FaGlobe size={16} className="text-purple-500 dark:text-purple-400 hidden sm:block" />
          <span className="text-xs sm:text-sm text-purple-600 dark:text-purple-400 font-medium">Global</span>
        </>
      ) : (
        <>
          <FaFolder size={14} className="text-blue-500 dark:text-blue-400 sm:hidden" />
          <FaFolder size={16} className="text-blue-500 dark:text-blue-400 hidden sm:block" />
          <span className="text-xs sm:text-sm text-blue-600 dark:text-blue-400 font-medium">Project</span>
        </>
      )}
    </div>
  );
};

export default ScopeIndicator;
